import React from 'react';
import TinyUrlApp from './Components/components/TinyUrlApp/TinyUrlApp';

function App() {
  return (
    <div className="App">
      <TinyUrlApp />
    </div>
  );
}

export default App;